<template>
			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12" v-if="data.params != null">
							<div class="nav-bar box-horizontal mb-0">
								<i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
								<div class="flex-1">
									<h3 class="m-0">{{data.params.user.unama}}</h3>
									<p class="mb-0">Berikut rinciannya</p>
								</div>
							</div>
			              <div class="card">
			                <div class="card-body">
								<div class="mb-4">
									<div class="row d-flex align-items-center pr-4">
										<img class="ml-4 profil" :src="data.foto" alt="">
										<div class="ml-4 form-group mr-auto">
											<h4 class="mb-0">{{data.params.user.unama}} <span class="text-info">( {{data.prefix}}{{data.params.user.fake_id}} )</span></h4>
											<label class="bmd-label-floating d-block"><span v-text="data.params.user.wa"></span></label>
											<label class="bmd-label-floating d-block text-secondary">
												Alamat : 
												<span v-text="data.alamat"></span>
												<span v-if="data.alamat == null"><button class="btn btn-sm btn-info" @click="data.modalAlamat = true">Tambah Alamat</button></span>
												<span v-else><span class="ml-3 text-info" style="cursor:pointer" @click="data.modalAlamat = true">Edit Alamat</span></span>
											</label>
											<label class="bmd-label-floating d-block text-info">
												<span><span class="text-secondary">Mikrotik</span> {{data.mikrotik}}</span>
												&#xb7; 
												<span><span class="text-secondary">PPPoE</span> {{data.params.user.ppoe}}</span> 
												&#xb7; 
												<span v-if="data.modem == null">
													<button class="btn btn-sm btn-info" @click="data.modalModem = true">Tambah Modem</button>
												</span>
												<span v-else>
													<span class="text-secondary">Modem</span> 
													{{data.modem}} 
												</span>
											</label>
										</div>
										<div>
											<button class="btn btn-success" @click="modal.modalBayarFunc">Bayar Tagihan</button>
										</div>
									</div>
								</div>
			                    <div class="row border-bottom mb-2">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-secondary">Tanggal Register</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10">
			                        <div class="form-group">
			                          <label class="bmd-label-floating"><span v-text="tglIndo(data.params.user.tanggal_register)"></span></label>
			                        </div>
			                      </div>
			                    </div>
			                    <div class="row border-bottom mb-2">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-secondary">Tanggal Tagihan</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10">
			                        <div class="form-group">
			                          <label class="bmd-label-floating"><span v-text="data.params.user.tanggal_tagihan"></span></label>
			                        </div>
			                      </div>
			                    </div>
			                    <div class="row border-bottom mb-2">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-secondary">Paket</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10">
			                        <div class="form-group">
			                          <label class="bmd-label-floating d-block"><span v-text="data.params.user.pnama"></span></label>
			                          <label class="bmd-label-floating d-block"><span>{{myGlobal.ribu(data.params.user.ptarif)}}</span></label>
			                        </div>
			                      </div>
			                    </div> 

			                    <div class="row border-bottom mb-2">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-secondary">PPN</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10">
			                        <div class="form-group">
			                          <label class="bmd-label-floating d-block"><span>{{data.ppnText}} %</span></label>
			                          <label class="bmd-label-floating d-block"><span>{{myGlobal.ribu( ( data.ppnText / 100 ) * data.params.user.ptarif ) }} </span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row border-bottom mb-2">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-secondary">Area</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10">
			                        <div class="form-group">
			                          <label class="bmd-label-floating"><span v-text="data.params.area"></span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row border-bottom mb-2">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-secondary">Biaya Tambahan</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10">
			                        <div class="form-group">
			                          <label class="bmd-label-floating"><span v-text="data.params.user.biaya_rincian"></span></label></br>
			                          <label class="bmd-label-floating"><span>{{myGlobal.ribu(data.params.user.biaya_tambahan)}}</span></label>
			                        </div>
			                        <div class="form-group">
			                          <label class="bmd-label-floating"><span v-text="data.params.user.biaya_rincian_2"></span></label></br>
			                          <label class="bmd-label-floating"><span>{{myGlobal.ribu(data.params.user.biaya_tambahan_2)}}</span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-secondary">Diskon</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating text-success">{{myGlobal.ribu(data.params.user.diskon)}}</label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Catatan</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">
										<span v-text="data.params.user.catatan"></span>
										<span v-if="data.params.user.catatan == '' || data.params.user.catatan == null" class="text-secondary">Tidak ada Catatan</span>
										</label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">ODP</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">
										<span v-html="data.odp"></span>
										<span v-if="data.odp == '' || data.odp == null" class="text-secondary">Tidak ada ODP</span>
										</label>
			                        </div>
			                      </div>
			                    </div>
								
			                </div>
			              </div>
			            </div>
		        	</div>
		        	
		        	<div class="row" v-if="data != null">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">History Pembayaran</h4>
							</div>
			                <div class="card-body">
								<div class="table-responsive">
									<table class="table">
										<thead class=" text-info">
											<th width="30px">No.</th>
											<th>Tagihan Bulan</th>
											<th>Paket</th>
											<th>Tarif</th>
											<th>Admin</th>
											<th>Isolir</th>
											<th>Aksi</th>
										</thead>
										<tbody v-if="data.datae.length != 0">
										<tr v-for="(ser, index) in data.datae">
											<td>{{ index+1 }}</td>
											<td><strong class="text-success">{{ ser.tanggal }}</strong><br><span>Byr tgl : {{ ser.tanggal_pembayaran }}</span></td> <!-- ini bulan cok -->
											<td>{{ ser.paket }}</td>
											<td>{{ myGlobal.ribu(ser.tarif) }}</td> 
											<td>{{ ser.by }}</td>
											<td>
												<span v-if="ser.is_isolir == 'ya'" class="text-danger">ISOLIR!!</span>
												<span v-else class="text-success">TIDAK</span>
											</td> <!-- ini bulan cok -->
											<td>
												<button class="btn btn-info btn-sm" @click="theGet.detail(
													ser.tanggal, ser.paket, ser.tarif, ser.ppn, ser.hDiskon, ser.tanggal_pembayaran, ser.tarif, ser.rincian1, ser.rincian2, ser.biaya1, ser.biaya2, ser.by, ser.paketTarif
												)"><i class="material-icons">remove_red_eye</i> Detail</button> 
											</td>
										</tr>
										</tbody>
										<tbody v-else>
											<td></td>
											<td>Tidak ada Data</td>
										</tbody>
									</table>
								</div>
			                </div>
			              </div>
			            </div>
		        	</div>

		      		<!-- MODAL DETAIL -->
					<div class="modal" tabindex="-1" role="dialog" v-show="data.modalDetail"> <!-- data.modalDetail -->
						<div class="overlay"></div>
						<div class="modal-dialog" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Detail Tagihan</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalDetail = false">
									  <span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
										<div class="col-md-12" style="height: 450px;overflow: auto;">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Nama Pelanggan</label>
													<p class="form-control">{{data.namaPelanggan}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Paket</label>
													<p class="form-control">{{cetak.form.PaketPrint}} - {{myGlobal.ribu(cetak.form.paketTarif)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Bulan <span class="text-danger" v-show="bayar.form.infoShow">{{bayar.form.info}}</span></label>
													<p class="form-control">{{cetak.form.TagihanBulanPrint}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Diskon</label>
													<p class="form-control">{{myGlobal.ribu(cetak.form.DiskonPrint)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Biaya Tambahan</label>
													<div class="row col-md-12">
														<p class="form-control col-md-6">{{cetak.form.Rincian1Print}}</p>
														<p class="form-control col-md-6">{{myGlobal.ribu(cetak.form.Biaya1Print)}}</p>
													</div>
													<label class="bmd-label-floating">Biaya Tambahan</label>
													<div class="row col-md-12">
														<p class="form-control col-md-6">{{cetak.form.Rincian2Print}}</p>
														<p class="form-control col-md-6">{{myGlobal.ribu(cetak.form.Biaya2Print)}}</p>
													</div>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Total Pembayaran</label>
													<strong class="form-control text-info" style="font-size: 16pt;">{{myGlobal.ribu(cetak.form.TarifPrint)}}</strong>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Admin</label>
													<p class="form-control">{{cetak.form.AdminByPrint}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<div v-show="data.afterBayar">
										<p>Pilih Kertas : </p>
										<small class="text-danger" v-show="cetak.form.kertasNull" >Pilih Kertas Terlebih dahulu</small>
									</div>
									<select v-model="cetak.form.kertas" class="form-control" style="width: 100px">
										<option value="" disabled selected>Pilih Kertas</option>
										<option value="POS">POS Print</option>
										<option value="A4">A4</option>
									</select>
									<button type="button" class="btn btn-info" @click="cetak.printBtn()">Print</button>
								</div>
							</div>
						</div>
					</div>
					<!-- MODEL DETAIL END -->

		      		<!-- MODAL -->
					<div class="modal" tabindex="-1" role="dialog" v-show="data.modalBayar"> <!-- data.modalBayar -->
						<div class="overlay"></div>
						<div class="modal-dialog" role="document" style="overflow:auto;height: 550px;">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Bayar Tagihan</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalBayar = false">
									  <span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="text-right">
										<div v-show="data.afterBayar">
											<p>Pilih Kertas : </p>
											<small class="text-danger" v-show="cetak.form.kertasNull" >Pilih Kertas Terlebih dahulu</small>
										</div>
										<button type="button" class="btn btn-success" @click="bayar.submit()" v-show="!data.afterBayar">Bayar Sekarang</button>
									</div>
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Nama Pelanggan</label>
													<input type="text" class="form-control" placeholder="Jumlah Topup..." v-model="data.namaPelanggan" disabled>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Paket</label>
													<p class="form-control">{{data.paketPelanggan}} - {{myGlobal.ribu(data.tarifPelanggan)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Bulan <span class="text-danger" v-show="bayar.form.infoShow">{{bayar.form.info}}</span></label>
								                	<select class="form-control" v-model="bayar.form.bulan" placeholder="Pilih Bulan...">
								                	  <option value="" disabled selected>Pilih Bulan</option>
												      <option value="01">Januari</option>
												      <option value="02">Februari</option>
												      <option value="03">Maret</option>
												      <option value="04">April</option>
												      <option value="05">Mei</option>
												      <option value="06">Juni</option>
												      <option value="07">Juli</option>
												      <option value="08">Agustus</option>
												      <option value="09">September</option>
												      <option value="10">Oktober</option>
												      <option value="11">November</option>
												      <option value="12">Desember</option>
												    </select>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Diskon</label>
													<div class="row col-md-12">
														<input type="number" class="form-control col-md-6" placeholder="Diskon..." v-model="data.diskon">
													</div>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Biaya Tambahan</label>
													<div class="row col-md-12">
														<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 1...." v-model="data.RincianTambahan1">
														<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 1...." v-model="data.BiayaTambahan1">
													</div>
													<label class="bmd-label-floating">Biaya Tambahan</label>
													<div class="row col-md-12">
														<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 2...." v-model="data.RincianTambahan2">
														<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 2" v-model="data.BiayaTambahan2">
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- MODEL END -->
					
		      		<!-- MODAL ALAMAT -->
					<div class="modal" tabindex="-1" role="dialog" v-show="data.modalAlamat"> <!-- data.modalBayar -->
						<div class="overlay"></div>
						<div class="modal-dialog" role="document" style="overflow:auto;height: 550px;">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Edit Alamat</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalAlamat = false">
									  <span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Alamat</label>
													<textarea class="form-control" rows="5" v-model="data.alamat">
													</textarea >
													
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<button class="btn btn-info" @click="data.modalAlamat = false, theGet.UpdateAlamat()">Update</button>
								</div>
							</div>
						</div>
					</div>
					<!-- MODEL ALAMAT END -->
					
		      		<!-- MODAL MODEM -->
					<div class="modal" tabindex="-1" role="dialog" v-show="data.modalModem"> <!-- data.modalBayar -->
						<div class="overlay"></div>
						<div class="modal-dialog" role="document" style="overflow:auto;height: 550px;">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Edit Alamat</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalModem = false">
									  <span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Modem</label>
													<input type="text" class="form-control col-md-6" placeholder="Modem...." v-model="data.modem">
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<button class="btn btn-info" @click="data.modalModem = false, theGet.UpdateModem()">Update</button>
								</div>
							</div>
						</div>
					</div>
					<!-- MODEL MODEM END -->
					
					<div id="nota" ref="nota" v-show="false" style="width:302px;font-family: Arial;">
						<p class="title-n" style="font-size: 14pt; text-align: center;;font-family: Arial;">{{data.namaQ}}</p>
						<div class="header-content" style="width:302px;margin-top:10px;float:left;margin-bottom:10px;">
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PELANGGAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{$route.params.user.unama}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{$route.params.user.wa}}</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PEMBAYARAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Tagihan Bulan : '+theBulan(bayar.form.bulan)}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Jenis Paket : '+$route.params.user.pnama}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Besar Iuran : '+$route.params.user.ptarif}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.ppnText != 0">{{'PPN '+data.ppnText+'% : '+data.ppn}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Tanggal Bayar : '+myGlobal.tglIndo(data.tglNow)}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Total : '+data.totalBayar}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Ket : L U N A S'}}</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;" v-if="data.RincianTambahan1 != '' || data.RincianTambahan2 != ''">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO BIAYA TAMBAHAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">{{data.RincianTambahan1}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">{{data.BiayaTambahan1}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">{{data.RincianTambahan2}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">{{data.BiayaTambahan2}}</p>
							</div>
							<div class="header-box" style="font-size: 10pt;width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO TAMBAHAN</strong></p>
								<p style="margin:0;font-family: Arial;">{{data.info}}</p>
							</div>
						</div>
					</div>
	        		
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import { url } from '@/var/var.js'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  	name: 'Beranda',
	components: { 

	}, 
    setup() {
		const data = reactive({
			params: null,
			title: "Detail Servis",
			datae: [],

			modalBayar: false,
			modalDetail: false,

			namaPelanggan: '',
			paketPelanggan: '',
			tahunBase: '',
			tarifPelanggan: '',
			RincianTambahan1: '',
			BiayaTambahan1: 0,
			RincianTambahan2: '',
			BiayaTambahan2: 0,
			diskon: 0,
			afterBayar: false,
			namaQ: '',
			tglNow: '',
			info: '',
			logo: '',
			ppn: 0,
			ppnText: '',
			totalBayar: 0, // tarif + tambahan 1 + tambahan 2 + ppn,

			prefix: "",
			alamat: null,
			modalAlamat: false,
			modalModem: false,
			modem: null,

			mikrotikid: '',
			mikrotik: '',
			odp: ''
		})

		const theBulan = function(x) {
			var bulan = ['', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
			return bulan[parseInt(x)];
		}

		const theGet = {
            form: reactive({
                kodeBarang: null
            }),
			datae() {
				var datax = new FormData();
				datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
				datax.append('id', data.params.id);
				
				var apiUrl = 'RincianUser';
				myGlobal.call(datax,apiUrl).then(x => {

					if (x.status == "true") {
						data.datae = x.data;
					} else {
						//alert(x.pesan);
					}
				})
			},
			UserDetail() {
				var datax = {
					token: 'TangTung '+sessionStorage.getItem('myToken'),
					id: data.params.id
				}
				
				var apiUrl = inter.UserDetail();
				myGlobal.call(datax,apiUrl).then(x => {

					//console.log(JSON.stringify(x));

					if (x.status == true) {

						var d = x.data;

						data.odp = "- Nomor ODP : " + d.nomor +
									"</br>- Nomor Kabel : " + d.kabel +
									"</br>- Nomor Port : " + d.port_ke +
									"</br>- Teknisi Pemasang : " + d.teknisi
						
					} else {
						
					}
				})
			},
			detail(bulan, paket, tarif, ppn, diskon, tanggal, total, rincian1, rincian2, biaya1, biaya2, by, pakettarif) { 
				// tarif = tarif yang sudah ada di history
				var tarifPaket = ( myGlobal.isNull(diskon) + myGlobal.isNull(tarif) ) - (myGlobal.isNull(biaya1) + myGlobal.isNull(biaya2) + myGlobal.isNull(ppn)); // di tambah diskon karena di awal sudah di kurangi diskon
				cetak.form.UNamaPrint = data.params.user.unama;
				cetak.form.UWaPrint = data.params.user.wa;
				cetak.form.TagihanBulanPrint = bulan;
				cetak.form.PaketPrint = paket;
				cetak.form.TarifPrint = tarif;
				cetak.form.paketTarif = pakettarif;
				cetak.form.PPNPrint = ppn;
				if (rincian1 != "null") {
					cetak.form.DiskonPrint = diskon;
				} else {
					cetak.form.DiskonPrint = "0";
				}
				//alert(tanggal);
				cetak.form.TanggalPrint = tanggal;
				cetak.form.TotalPrint = total;
				if (rincian1 != "null") {
					cetak.form.Rincian1Print = rincian1;
					cetak.form.Biaya1Print = biaya1;
				} else {
					cetak.form.Rincian1Print = "-";
					cetak.form.Biaya1Print = "0";
				}
				if (rincian2 != "null") {
					cetak.form.Rincian2Print = rincian2;
					cetak.form.Biaya2Print = biaya2;
				} else {
					cetak.form.Rincian2Print = "-";
					cetak.form.Biaya2Print = "0";
				}
				cetak.form.AdminByPrint = by;
				data.modalDetail = true;
			},
			mikrotikDetail() {
				//console.log(data.mikrotikid);
				var datax = {
					token: 'TangTung '+sessionStorage.getItem('myToken'),
					id: data.mikrotikid
				}
				
				var apiUrl = inter.mikrotikDetail();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status == true) {
						data.mikrotik = x.data.nama;
					} else {
						//alert(x.pesan);
					}
				})
			}, 
			UpdateModem() {
				var datax = {
					token: 'TangTung '+sessionStorage.getItem('myToken'),
					id: data.params.id,
					text: data.modem
				}
				
				var apiUrl = inter.modemUpdate();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status == true) {
						data.modem = data.modem;
					} else {
						//alert(x.pesan);
					}
				})
			},
			UpdateAlamat() {
				var datax = {
					token: 'TangTung '+sessionStorage.getItem('myToken'),
					id: data.params.id,
					text: data.alamat
				}
				
				var apiUrl = inter.PelangganAlamatUpdate();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status == true) {
						data.alamat = data.alamat;
					} else {
						//alert(x.pesan);
					}
				})
			}
		}

		const bayar = {
            form: reactive({
				info: null,
				infoShow: false,
				bulan: ""
            }),
			submit() {	
				
				if (bayar.form.bulan == "") {
					bayar.form.infoShow = true;
					bayar.form.info = "Pilih Bulan Terlebih dulu";
					return false;
				}

				data.ppn = ( parseInt(sessionStorage.getItem('PPN')) / 100 ) * parseInt(data.params.user.ptarif);
				data.totalBayar = (parseInt(data.params.user.ptarif)+parseInt(data.BiayaTambahan1)+parseInt(data.BiayaTambahan2)+parseInt(data.ppn)) - parseInt(data.diskon);

				
				var datax = {
					token: 'TangTung '+sessionStorage.getItem('myToken'),
					id: data.params.user.uid,
					bulantahun0: data.tahunBase +"-"+ bayar.form.bulan,
					biaya1: data.BiayaTambahan1,
					biaya2: data.BiayaTambahan2,
					rincian1: data.RincianTambahan1,
					rincian2: data.RincianTambahan2,
					diskon: data.diskon
				}
				//     
				var apiUrl = inter.postBayarNew();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status) {
					
						//data.afterBayar = true;
						data.modalBayar = false;
						theGet.datae();

					} else {

						// alert(x.pesan);

					}
				})

				/*
				if (bayar.form.bulan == "") {
					bayar.form.infoShow = true;
					bayar.form.info = "Pilih Bulan Terlebih dulu";
					return false;
				}

				data.ppn = ( parseInt(sessionStorage.getItem('PPN')) / 100 ) * parseInt(data.params.user.ptarif);
				data.totalBayar = (parseInt(data.params.user.ptarif)+parseInt(data.BiayaTambahan1)+parseInt(data.BiayaTambahan2)+parseInt(data.ppn)) - parseInt(data.diskon);

				var datax = new FormData();
				datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
				datax.append('id', data.params.user.uid);
				datax.append('bulan', bayar.form.bulan);
				datax.append('tahun', data.tahunBase);
				datax.append('biaya1', data.BiayaTambahan1);
				datax.append('rincian1', data.RincianTambahan1);
				datax.append('biaya2', data.BiayaTambahan2);
				datax.append('rincian2', data.RincianTambahan2);
				datax.append('diskon', data.diskon);
				
				var apiUrl = 'BayarSekarang';
				myGlobal.call(datax,apiUrl).then(x => {
					if (x.status) {
						//data.afterBayar = true;
						data.modalBayar = false;
						theGet.datae();
					} else {
					//alert(x.pesan);
					}
				})
				*/
			}
		}
		

		const modal = {
			modalBayarFunc() {
				data.modalBayar = true;
			}
		}

		const cetak = {
            form: reactive({
				kertas: "",
				kertasNull: false,

				namaQPrint: "",
				UNamaPrint: "",
				UWaPrint: "",
				TagihanBulanPrint: "",
				PaketPrint: "",
				paketTarif: '', // tarif paket awal sebelum ke history
				TarifPrint: "",
				PPNPrint: "",
				DiskonPrint: "",
				TanggalPrint: "",
				TotalPrint: "",
				Rincian1Print: "",
				Rincian2Print: "",
				Biaya1Print: "",
				Biaya2Print: "",
				AdminByPrint: "",
				foto: '',
				alamat: '',
				
            }),
			printBtn() {
				if (cetak.form.kertas == "") {
					cetak.form.kertasNull = true;
					return false;
				} else {
					cetak.form.kertasNull = false;
				}

				if (cetak.form.kertas == "A4") {
					cetak.printA4();
				} else {
					cetak.print();
				}
			},
			print() {
			// Pass the element id here
				data.modalBayar = false;
				

				var newWin=window.open('','Print-Window');

				newWin.document.open();

				newWin.document.write(`<html><style>@page {size:75mm auto; margin: 0mm 0mm 0mm 0mm;}</style><body style="width:75mm">
					<div id="nota" ref="nota" v-show="false" style="width:302px;font-family: Arial;">
						<p class="title-n" style="font-size: 14pt; text-align: center;;font-family: Arial;"><strong>`+data.namaQ+`</strong></p>
						<div class="header-content" style="width:302px;margin-top:10px;float:left;margin-bottom:10px;">
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PELANGGAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+cetak.form.UNamaPrint+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+cetak.form.UWaPrint+`</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PEMBAYARAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Tagihan Bulan : '+cetak.form.TagihanBulanPrint+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Jenis Paket : '+cetak.form.PaketPrint+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Besar Iuran : '+myGlobal.ribu(cetak.form.paketTarif)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.ppnText != 0">`+'PPN '+data.ppnText+'% : '+myGlobal.ribu(cetak.form.PPNPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Diskon : '+myGlobal.ribu(cetak.form.DiskonPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Tanggal Bayar : '+cetak.form.TanggalPrint+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Total : '+myGlobal.ribu(cetak.form.TotalPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Ket : L U N A S'+`</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;" v-if="data.RincianTambahan1 != '' || data.RincianTambahan2 != ''">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO BIAYA TAMBAHAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">`+cetak.form.Rincian1Print+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">`+myGlobal.ribu(cetak.form.Biaya1Print)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">`+cetak.form.Rincian2Print+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">`+myGlobal.ribu(cetak.form.Biaya2Print)+`</p>
							</div>
							<div class="header-box" style="font-size: 10pt;width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO TAMBAHAN</strong></p>
								<p style="margin:0;font-family: Arial;">`+data.info+`</p>
							</div>
						</div>
					</div>
				</body></html>`);

				newWin.print();

				//newWin.document.close();

				//setTimeout(function(){newWin.close();},10);

				//this.print();

			},
			printA4() {
			// Pass the element id here
				data.modalBayar = false;
				

				var newWin=window.open('','Print-Window');

				newWin.document.open();
				newWin.document.write(`<html>
					<head>
					<meta charset="utf-8">
					<title>Untitled Document</title>
					<style>
						@page {size:210mm auto; margin: 0mm 0mm 0mm 0mm;}
						* {
							font-family: Arial, Helvetica, sans-serif;
						}
						body,html,p,h3,h2 {
							margin: 0;
							padding: 0;
						}
						.wrapper {
							margin: 10px;
							padding: 10px;
							border: 3px solid #aeaeae;
						}
						.rtrw {
							font-size: 17pt;
							color: #3498db;
						}
						.telp {
							margin-bottom: 10px;
							font-size: 14pt;
							color: #808080;
						}
						.title {
							font-size: 13pt;
							margin-bottom: 20px;
						}
						.item-title {
							padding-right: 30px;
						}
						.tanggal {
							margin-bottom: 20px;
							text-align: right;
						}
						.catatan {
							text-align: center;
							margin-top: 10px;
						}
						.gray {
							color: #808080;
							font-size: 10pt;
						}
						.header {
							color: #3498db;
							border-bottom: 1px solid #808080;
							padding: 10px 0;
						}
						.content {
							padding: 5px 0;
						}
						.logo {
							width: 75px;
						}
					</style>
					</head>
						
					<body>
						<div class="wrapper">
							<table style="width: 100%;">
								<tr>
									<td>
										<h2 class="rtrw">`+data.namaQ+`</h2>
										<p class="title">Struk Pembayaran</p>
									</td>
									<td style="text-align:right">
										<img src="https://blonjo.web.id/beat/API/WIFI/images/`+data.logo+`" class="logo">
									</td>
								</tr>
							</table>
								
							<div class="content">
								<table style="width: 100%;">
									<tr>
										<td>
											<div>
												<table style="width: 100%;">
													<tr>
														<th class="header">
															Deskripsi
														</th>
														<th class="header" style="text-align:right">
															Jumlah
														</th>
													</tr>
													<tr>
														<td class="content">
															`+cetak.form.PaketPrint+`
														</td>
														<td class="content" style="text-align:right">
															`+myGlobal.ribu(cetak.form.paketTarif)+`
														</td>
													</tr>
													<tr>
														<td class="content">
															`+'PPN '+data.ppnText+`%
														</td>
														<td class="content" style="text-align:right">
															`+myGlobal.ribu(cetak.form.PPNPrint)+`
														</td>
													</tr>
													<tr>
														<td class="content">
															`+cetak.form.Rincian2Print+`
														</td>
														<td class="content" style="text-align:right">
															`+myGlobal.ribu(cetak.form.Biaya2Print)+`
														</td>
													</tr>
													<tr>
														<td class="content">
															`+cetak.form.Rincian1Print+`
														</td>
														<td class="content" style="text-align:right">
															`+myGlobal.ribu(cetak.form.Biaya1Print)+`
														</td>
													</tr>
													<tr>
														<td class="content">
															Diskon
														</td>
														<td class="content" style="text-align:right">
															`+myGlobal.ribu(cetak.form.DiskonPrint)+`
														</td>
													</tr>
													<tr>
														<th class="header">
														</th>
														<th class="header" style="text-align:right">
														</th>
													</tr>
												</table>
											</div>
										</td>
										<td style="text-align:right">
											<p class="gray">Total Iuran</p>
											<p style="font-size: 20pt;margin-bottom: 20px;color: #3498db;"><strong>`+myGlobal.ribu(cetak.form.TotalPrint)+`</strong></p>

											<p class="gray">Bayar A.n.</p>
											<p style="font-size: 16pt;">`+data.params.user.unama+`</p>
											<p style="font-size: 16pt;margin-bottom: 20px;">`+data.params.user.wa+`</p>

											<p class="gray">Tagihan Bulan</p>
											<p style="margin-bottom: 20px;">`+cetak.form.TagihanBulanPrint+`</p>

											<p class="gray">Tanggal</p>
											<p style="margin-bottom: 20px;">`+cetak.form.TanggalPrint+`</p>
										</td>
									</tr>
								</table>
							</div>
							<p class="catatan">`+data.info+`</p>
						</div>
					</body>
					</html>
				`);

				/*
				newWin.document.write(`<html>
					<style>
						@page {size:210mm auto; margin: 0mm 0mm 0mm 0mm;}
						* {
							font-family: Arial, Helvetica, sans-serif;
						}
						body,html,p,h3,h2 {
							margin: 0;
							padding: 0;
						}
						.wrapper {
							margin: 10px;
							padding: 10px;
							border: 3px solid #aeaeae;
						}
						.rtrw {
							margin-bottom: 10px;
							text-align: center;
							font-size: 17pt;
						}
						.title {
							text-align: center;
							font-size: 13pt;
							margin-bottom: 20px;
						}
						.item-title {
							padding-right: 30px;
						}
						.tanggal {
							margin-bottom: 20px;
							text-align: right;
						}
						.catatan {
							text-align: center;
							margin-top: 10px;
						}
					</style>
					<body>
						<div class="wrapper">
							<h2 class="rtrw">`+data.namaQ+`</h2>
							<p class="title">Struk Pembayaran </p>
							<p class="tanggal">`+'Tanggal Bayar : '+myGlobal.tglIndo(cetak.form.TanggalPrint)+`</p>
								
							<div class="content">
								<table>
									<tr>
										<td class="item-title">Nama</td>
										<td> : </td>
										<td> `+data.params.user.unama+` - `+data.params.user.wa+`</td>
									</tr>
									<tr>
										<td class="item-title">Paket</td>
										<td> : </td>
										<td> `+cetak.form.PaketPrint+` </td>
									</tr>
									<tr>
										<td class="item-title">Besar Iuran</td>
										<td> : </td>
										<td> `+myGlobal.ribu(cetak.form.TarifPrint)+` </td>
									</tr>
									<tr>
										<td class="item-title">`+'PPN '+data.ppnText+`%</td>
										<td> : </td>
										<td> `+myGlobal.ribu(cetak.form.PPNPrint)+` </td>
									</tr>
									<tr>
										<td class="item-title">Biaya Tambahan</td>
										<td> : </td>
										<td> `+cetak.form.Rincian1Print+` - `+myGlobal.ribu(cetak.form.Biaya1Print)+` </td>
									</tr>
									<tr>
										<td class="item-title"></td>
										<td> : </td>
										<td> `+cetak.form.Rincian2Print+` - `+myGlobal.ribu(cetak.form.Biaya2Print)+` </td>
									</tr>
									<tr>
										<td class="item-title">Diskon</td>
										<td> : </td>
										<td> `+myGlobal.ribu(cetak.form.DiskonPrint)+` </td>
									</tr>
									<tr>
										<td class="item-title">Total Biaya</td>
										<td> : </td>
										<td> `+myGlobal.ribu(cetak.form.TotalPrint)+` </td>
									</tr>
									<tr>
										<td class="item-title">Keterangan</td>
										<td> : </td>
										<td> LUNAS </td>
									</tr>
									<tr>
										<td class="item-title">Tagihan Bulan</td>
										<td> : </td>
										<td> <strong>`+cetak.form.TagihanBulanPrint+`</strong></td>
									</tr>
								</table>
							</div>
							<p class="catatan">`+data.info+`</p>
						</div>
					</body>
				</html>`);
				*/

				newWin.print();

				newWin.document.close();

				setTimeout(function(){newWin.close();},10);

				//this.print();

			}
		}

        return {
            myGlobal,
			data,
			theBulan,
			theGet,
			modal,
			cetak,
			bayar
		}
	},
    mounted () {
    	document.title = "Detail Pelanggan";

		// kalo disini pake this
		this.data.params = this.$route.params;

		//console.log(JSON.stringify(this.data.params));

		this.theGet.datae();

		this.data.namaPelanggan = this.$route.params.user.unama;
		
		this.data.paketPelanggan = this.$route.params.user.pnama;
		this.data.tarifPelanggan = this.$route.params.user.ptarif;
		this.data.RincianTambahan1 =  (this.$route.params.user.biaya_rincian === null) ? '' : this.$route.params.user.biaya_rincian;
		this.data.BiayaTambahan1 = (this.$route.params.user.biaya_tambahan === null) ? '' : this.$route.params.user.biaya_tambahan;
		this.data.RincianTambahan2 = (this.$route.params.user.biaya_rincian_2 === null) ? '' : this.$route.params.user.biaya_rincian_2;
		this.data.BiayaTambahan2 = (this.$route.params.user.biaya_tambahan_2 === null) ? '' : this.$route.params.user.biaya_tambahan_2; 
		this.data.diskon = (this.$route.params.user.diskon === null) ? '' : this.$route.params.user.diskon; 

		this.data.namaQ = sessionStorage.getItem('admin');
		
		var date = new Date();
		this.data.tglNow = moment(date).format('YYYY-MM-DD');

		this.data.info = sessionStorage.getItem('myInfoPrint');
		this.data.logo = sessionStorage.getItem('logo');
		this.data.foto = 'https://beatcom.web.id/tagihan_user_assets/images/profil/thumb_'+this.data.params.user.foto;
		this.data.alamat = this.data.params.user.alamat;

		this.data.modem = this.data.params.user.modem_info;

		this.data.ppnText = sessionStorage.getItem('PPN');
		
    	this.data.tahunBase = myGlobal.getTahunNow();

		this.data.prefix = sessionStorage.getItem('prefix');

		this.data.mikrotikid = this.data.params.user.mikrotik_id;

		this.theGet.mikrotikDetail();

		this.theGet.UserDetail();

    }
}
/*
export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
	methods: {,
	},
	mounted() {
	}
}
*/
</script>

<style scoped>
p {
	margin: 0 !important;
}
.edit-input {
	font-size: 20pt !important;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
.profil {
	width: 80px;
	height: 80px;
	border-radius: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/pelanggan/detail.vue